
import { defineComponent, nextTick } from 'vue';

import PrzLoader from '@/components/Muffin/Loader.vue';
import request from '@/Utilities/httpRequest';

export default defineComponent({
    components:{
        PrzLoader
    },
    props: {
        postId: {
            type: String,
            default: undefined
        },
        parentId: {
            type: String,
            default: undefined
        },
        allowCancel:{
            type: Boolean,
            default: true
        },
        saveUrl: {
            type: String,
            default: undefined
        },
        successMessage: {
            type: String,
            default: undefined
        },
        isGuest: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: undefined
        },
        isAbleToDoNewComment:{
            type: Boolean,
            default: true
        },
    },
    mounted(){
        setTimeout(() => { 
            this.expand = true; 
            setTimeout(() => {
                this.calcTextHeight(null);
            },250);
        },5);
    },
    data(){
        let textBoxStyle: any = {
            'overflow-y': 'hidden'
        }
        let msgSentStyle: any = {
            'width': '10%'
        }
        let newCommentText: string | undefined;
        return {
            textBoxStyle,
            showLoader: false,
            msgSent: false,
            success: false,
            resultMessage: '',
            textHeight: 0,
            newCommentText,
            msgSentStyle,
            expand: false
        }
    },
    methods:{
        async calcTextHeight(e: any) {
            let key = (e?.key ?? '').toLowerCase();
            let keyCode = e?.keyCode ?? 0;

            //code 229 is backspace on android
            if (key == 'unidentified' && keyCode == 229) {
                key = "backspace";
            }
            if ((key === "backspace" || key === "delete")) {
                this.textBoxStyle = { 'overflow-y': 'hidden' };
                await nextTick();
            }
            try {
                let textBox: HTMLTextAreaElement | null = this.$el.querySelector('.prz-social-new-comment-input');
                if (textBox) {
                    this.setNewCommentHeight(textBox.scrollHeight);
                }
            } catch (error) { }
        },
        setNewCommentHeight(newHeight: number) {
            let dialogHeight = 9999;
            if(this.parentId){
                let dialog: HTMLElement | null = this.$el.closest('.prz-social-dialog');
                if(dialog){
                    dialogHeight = (dialog.offsetHeight ?? 9999) - 50;
                }
            }
            let maxHeight: number = Math.min(150,dialogHeight);
            //this.textHeight = newHeight > maxHeight ? maxHeight : newHeight;
            this.textHeight = Math.min(newHeight,maxHeight);
            this.textBoxStyle = {
                'overflow-y': newHeight > maxHeight ? 'auto' : 'hidden',
                'max-height': `${maxHeight}px`,
                'height': `${newHeight}px`
            };
        },
        async sentMsg() {
            if (!this.newCommentText || !this.newCommentText.replace(' ', '')) {
                return null;
            }
            this.showLoader = true;
            this.resultMessage = '';
            this.msgSentStyle = { 'width': '10%' };

            await nextTick();

            let params: any = {
                comment: this.newCommentText,
                postId: this.postId,
                parentId: this.parentId
            };
            let { data } = await request.post(this.saveUrl, params, false);
            this.success = (data?.id ?? null) ? true : false;
            this.resultMessage = data?.message ?? data?.result?.content ?? data.details?.data?.result?.content ?? '';
            this.msgSent = true;

            setTimeout(() => {
                this.msgSentStyle = { 'width': 'calc(100% + 4px)' };
            },5);

            if (this.success) {
                this.newCommentText = "";
                this.textBoxStyle = { 'overflow-y': 'hidden' };
            }

            setTimeout(() => {
                this.msgSentStyle = { 'width': '10%'  };
                const el = document.querySelector('.prz-social-metion-tabs');
                if (el && !this.parentId) {
                    el.scrollTo(0, 0);
                }

                setTimeout(() => {
                    this.msgSent = false;
                }, 200);

                if (this.success) {
                    this.$emit('reload');
                }
            }, 5000);
            this.showLoader = false;
        }
    }
});
